module.exports = __webpack_public_path__ + "static/text-999bb6157a815013250d05de0e19df3e.png";